import { Box, Stack } from '@mui/material'
import { ToggleButton } from '@omnea-app/frontend/components/shared/ui/toggle-button/ToggleButton'

type ResolveButtonsProps = {
  loading: boolean
  unresolvedMentionsCount: number
  handleResolveChange: (value: boolean) => void
  showResolved: boolean
  translate: (key: string) => string
}

export const ResolveButtons = ({
  loading,
  unresolvedMentionsCount,
  handleResolveChange,
  showResolved,
  translate,
}: ResolveButtonsProps) => {
  return (
    <Stack
      sx={{
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      <ToggleButton
        label={
          <>
            {translate('mentions.unresolved')}
            {!loading && unresolvedMentionsCount !== 0 && (
              <Box
                sx={{
                  bgcolor: 'neutralLight.900',
                  color: 'neutralLight.300',
                  borderRadius: 10,
                  padding: '0px 4px',
                  fontSize: 8,
                  marginLeft: '4px',
                  minWidth: '14px',
                }}
                data-testid="mentions-list-unresolved-count"
              >
                {unresolvedMentionsCount}
              </Box>
            )}
          </>
        }
        onClick={() => handleResolveChange(false)}
        isSelected={!showResolved}
      />
      <ToggleButton
        label={<>{translate('mentions.resolved')}</>}
        onClick={() => handleResolveChange(true)}
        isSelected={showResolved}
      />
    </Stack>
  )
}
